
	import Vue from "vue"
	import Component from "vue-class-component"
	import { Company, Address } from "store/company/types"
	import { companyModule } from "store/modules"

	@Component
	export default class MyCompany extends Vue {
		@companyModule.Getter company!: Company

		readonly baseTranslationKey = "profile.myCompany"

		get businessAddress(): Address | undefined {
			return this.company?.address?.business
		}
	}
